import React, { useEffect, useState } from 'react';
import NotificationsV2 from '../notificationsV2';

/**
 * The soft ask: the site's own card offering push before the browser's prompt, which only a click
 * on "Aceptar" triggers (browsers ignore or quiet a prompt without a user action). Shown to a
 * signed-in user when the brand registers web endpoints, the browser supports push and the user
 * was never asked; "Ahora no" hides it for SNOOZE_DAYS.
 */
const SNOOZE_DAYS = 7;
const SNOOZE_KEY = `${process.env.REACT_APP_STORAGE_PREFIX}_NOTIFICATIONS_PROMPT_SNOOZED_AT`;

const snoozed = () => {
  try {
    const at = Number(window.localStorage.getItem(SNOOZE_KEY)) || 0;
    return Date.now() - at < SNOOZE_DAYS * 24 * 60 * 60 * 1000;
  } catch {
    return false;
  }
};

const snooze = () => {
  try {
    window.localStorage.setItem(SNOOZE_KEY, String(Date.now()));
  } catch {
    /* shown again next time */
  }
};

const NotificationsPrompt = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let active = true;

    if (!snoozed()) {
      NotificationsV2.getPushAvailability().then(({ available, permission }) => {
        if (active && available && permission === 'unknown') {
          setVisible(true);
        }
      });
    }

    return () => {
      active = false;
    };
  }, []);

  if (!visible) {
    return null;
  }

  const accept = () => {
    setVisible(false);
    NotificationsV2.requestPermission();
  };

  const dismiss = () => {
    setVisible(false);
    snooze();
  };

  return (
    <div
      className="card rounded-12 shadow border border-gray-50 position-fixed bottom-0 end-0 m-3 p-3"
      style={{ zIndex: 1080, maxWidth: 360 }}
      role="dialog"
      aria-live="polite"
    >
      <p className="mb-3">Recibí novedades sobre tu cuenta de Grisino Fan</p>
      <div className="d-flex justify-content-end">
        <button className="btn btn-link me-2" onClick={dismiss}>
          Ahora no
        </button>
        <button className="btn btn-primary" onClick={accept}>
          Aceptar
        </button>
      </div>
    </div>
  );
};

export default NotificationsPrompt;
